import { DialogService, ResponseStatus, WidgetStyle } from '@sdbn/common';
import { ResponseMessage } from '@sdbn/common';
import { NgForm } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { TaskAdministrationService } from '../service/tasks-administration.service';
import { MasterDetailListEntry } from '@sdbn/common';
import { Subscription } from 'rxjs';
import { AbstractWidgetComponent } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';
import { SelectDocumentDialogComponent, SelectDocumentDialogComponentData } from './task-details/select-document-dialog.component';
import { DictionaryEntry } from '@sdbn/common';
import { TranslationService } from '@sdbn/common';

import { TaskDetails, TaskExecutionType, TaskType, Task } from '../task.model';

@Component({
  selector: 'app-tasks-admin',
  templateUrl: './tasks.component.html',
  styleUrls: ['./tasks.component.scss']
})
export class TasksAdminComponent extends AbstractWidgetComponent implements OnInit, OnDestroy {

  tasks: Task[] = [];

  selectedTask: Task;
  selectedDetails: TaskDetails = new TaskDetails();
  workingCopyDetails: TaskDetails = new TaskDetails();

  responseMessages: ResponseMessage[];
  isLoading = false;

  get cancelEnabled() {
    return !this.isLoading && this.form != null && this.form.dirty;
  }

  get saveEnabled() {
    if (this.workingCopyDetails?.type === TaskType.DOCUMENT && this.workingCopyDetails?.documentTemplate == null) {
      return false;
    } if (this.workingCopyDetails?.type === TaskType.MESSAGE && !this.workingCopyDetails.message?.checkValueExistsForLanguage('de')) {
      return false;
    } else {
      return !this.isLoading && this.form != null && this.form.dirty && this.form.valid && this.workingCopyDetails.name?.checkValueExistsForLanguage('de')
    }
  }

  @ViewChild('displayForm') form: NgForm;

  languageSubscription: Subscription;

  taskType = TaskType;
  taskTypes: TaskType[] = [];
  taskExecutionTypes: TaskExecutionType[] = [];

  constructor(
    private taskService: TaskAdministrationService,
    private dialog: MatDialog,
    public translationService: TranslationService,
    private dialogService: DialogService
  ) {

    super();

    this.selectedDetails = this.createEmptyDetails();
    this.workingCopyDetails = this.createEmptyDetails();

    this.languageSubscription = this.translationService.changed.subscribe(language => {
      this.createTranslatedValuesOnList();
    });

    for (const o of Object.keys(TaskType)) {
      this.taskTypes.push(TaskType[o]);
    }
    for (const o of Object.keys(TaskExecutionType)) {
      this.taskExecutionTypes.push(TaskExecutionType[o]);
    }

  }

  createTranslatedValuesOnList() {
    for (const supplementaryEquipment of this.tasks) {
      supplementaryEquipment.translatedLabel = this.translationService.translate(supplementaryEquipment.nameDictionaryKey);
    }
  }

  ngOnInit() {
    this.load();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();

    if (this.languageSubscription != null) {
      this.languageSubscription.unsubscribe();
    }
  }

  setSelected(task: Task) {

    if (this.selectedTask != null && this.selectedTask.id === task.id) {
      return;
    }

    if (this.form?.form?.dirty) {

      this.dialogService.showConfirm(
        'tmc.admin.tasks.discard.confirm-dialog.title',
        'tmc.admin.tasks.discard.confirm-dialog.message'
      ).afterClosed().subscribe(() => {
        this.setSelectedWithoutCheck(task);
      });

    } else {
      this.setSelectedWithoutCheck(task);
    }

  }

  setSelectedWithoutCheck(task: Task) {
    console.log('task is', task);
    this.selectedTask = task;
    this.setLoading(true);
    this.responseMessages = [];
    if (this.form != null) {
      this.form.resetForm();
    }
    if (task != null && task.id > 0) {
      this.taskService.getTaskDetails({ id: task.id }).subscribe(details => {
        if (details != null) {
          this.selectedDetails = details;
          this.workingCopyDetails = new TaskDetails(details);
        } else {
          this.clear();
        }
        this.setLoading(false);
      }, error => {
        this.setLoading(false);
        console.log(error);
      });
    } else {
      this.setLoading(false);
    }
  }

  isSelected(details: Task) {
    return this.selectedDetails != null && this.selectedDetails.id === details.id;
  }

  delete(task: Task) {

    this.responseMessages = [];


    this.dialogService.showConfirm(
      'tmc.admin.tasks.delete.confirm-dialog.title',
      'tmc.admin.tasks.delete.confirm-dialog.message'
    ).afterClosed().subscribe(() => {
      this.setLoading(true);

      this.taskService.deleteTask({ id: task.id }).subscribe(response => {
        if (response.status === ResponseStatus.SUCCESS) {
          this.clearAndLoad();
        } else {
          this.responseMessages = response.responseMessages;
        }
        this.setLoading(false);
      }, error => {
        console.log(error);
        this.setLoading(false);
      });
    });

  }

  load() {
    this.setLoading(true);
    this.responseMessages = [];
    this.taskService.getTasks().subscribe(tasks => {

      const newTasks = new Array<Task>();
      for (const task of tasks) {
        newTasks.push(new Task(task));
      }
      this.tasks = newTasks;

      if (tasks.length > 0) {
        if (this.selectedTask == null) {
          this.setSelectedWithoutCheck(this.tasks[0]);
        } else {
          const oldSelected = this.tasks.find(s => s.id === this.selectedTask.id);
          if (oldSelected != null) {
            this.setSelectedWithoutCheck(oldSelected);
          } else {
            this.setSelectedWithoutCheck(this.tasks[0]);
          }
        }
      }

      this.setLoading(false);

      this.createTranslatedValuesOnList();
    }, error => {
      console.error(error);
      this.setLoading(false);
    });
  }

  addNew() {
    if (this.form.form.dirty) {

      this.dialogService.showConfirm(
        'tmc.admin.tasks.discard.confirm-dialog.title',
        'tmc.admin.tasks.discard.confirm-dialog.message'
      ).afterClosed().subscribe(() => {
        this.clear();
      });

    } else {
      this.clear();
    }
  }

  cancel() {
    if (this.form.form.dirty) {

      this.dialogService.showConfirm(
        'tmc.admin.tasks.discard.confirm-dialog.title',
        'tmc.admin.tasks.discard.confirm-dialog.message'
      ).afterClosed().subscribe(() => {
        this.discardChanges();
      });

    } else {
      this.discardChanges();
    }
  }

  discardChanges() {
    this.responseMessages = [];
    if (this.workingCopyDetails.id === -1) {
      this.clear();
    } else {
      this.setSelectedWithoutCheck(this.selectedTask);
    }
  }

  private clear() {
    this.responseMessages = [];
    this.selectedTask = null;

    this.selectedDetails = this.createEmptyDetails();

    this.workingCopyDetails = new TaskDetails(this.selectedDetails);
    this.form.reset(this.workingCopyDetails);
  }

  private createEmptyDetails(): TaskDetails {
    const details = new TaskDetails();
    details.executionType = TaskExecutionType.ONCE;
    details.type = TaskType.CHECK;
    details.name = new DictionaryEntry();
    details.message = new DictionaryEntry();
    details.id = -1;

    return details;
  }

  clearAndLoad() {
    this.clear();
    this.load();
  }

  save() {

    this.setLoading(true);
    this.responseMessages = [];
    if (this.workingCopyDetails.id === -1) {
      this.createDetails(this.workingCopyDetails);
    } else {
      this.updateDetails(this.workingCopyDetails);
    }

  }

  private updateDetails(detailsToUpdate: TaskDetails) {
    this.taskService.saveTask(detailsToUpdate).subscribe(response => {
      this.setLoading(false);
      if (response.status === ResponseStatus.SUCCESS) {
        this.selectedDetails = new TaskDetails(this.workingCopyDetails)
        this.form.resetForm();

        this.load();

      } else {
        this.responseMessages = response.responseMessages;
      }
    }, error => {
      console.log(error);
      this.setLoading(false);
    });
  }

  private createDetails(detailsToAdd: TaskDetails) {
    this.taskService.createTask(detailsToAdd).subscribe(response => {
      this.setLoading(false);
      if (response.status === ResponseStatus.SUCCESS) {
        this.clearAndLoad();
      } else {
        this.responseMessages = response.responseMessages;
      }
    }, error => {
      console.log(error);
      this.setLoading(false);
    });
  }



  onSelectionChanged(entry: MasterDetailListEntry) {
    this.setSelected(entry as Task);
  }

  onAddEntry(parentPath: Array<MasterDetailListEntry>) {
    this.addNew();
  }

  onDeleteEntry(entry: MasterDetailListEntry) {
    this.delete(entry as Task);
  }

  onContextChange(contextChange: ContextChange) {
  }

  onSetElementAndContext() {
  }

  public selectDocument() {

    this.taskService.getDocuments().subscribe(
      docs => {
        const data = new SelectDocumentDialogComponentData();
        data.documents = docs;
        if (this.workingCopyDetails.documentTemplate != null) {
          data.selected = docs.find(d => d.id === this.workingCopyDetails.documentTemplate.id);
        }

        this.dialog.open(SelectDocumentDialogComponent, { data }).afterClosed().subscribe(
          selection => {
            if (selection != null) {
              this.workingCopyDetails.documentTemplate = selection;
              this.form.form.markAsDirty();
            }
          }
        );
      }
    );
  }

  public onDictionaryChanged() {
    this.form.form.markAsDirty();
  }

  private setLoading(loading: boolean) {
    this.isLoading = loading;
  }

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }
}
